import * as React from 'react'
import _ from 'lodash' 
import styled, { keyframes }  from 'styled-components'

const MonitorContainer = styled.div`
  border: 1px solid ${(props) => props.theme.primaryColor};
  border-top: none;
  color: ${(props) => props.theme.primaryColor};
  overflow: none;
  padding: .5em 0;
  margin-bottom: 1em;
`

const AnimateDash = keyframes`
  to {
    stroke-dashoffset: 0;
  }
`

const Line = styled.line`
  fill: none;
  stroke: ${(props) => props.theme.highlightColor};
  stroke-width: 20px;
  pointer-events: none;
  animation: ${AnimateDash} 120s linear alternate infinite;
`

const LineOne = styled(Line)`
  stroke-dasharray: ${_.random(20,40)} ${_.random(75,150)} ${_.random(100,200)};
  stroke-dashoffset: 8000;
`

 const LineTwo = styled(Line)`
  stroke-dasharray: ${_.random(15,25)} ${_.random(20,40)} ${_.random(20,35)} ${_.random(50,60)} ${_.random(60,80)};
  stroke-dashoffset: 12000;
`

const SystemMonitor = (props) => {

  return(
    <MonitorContainer>
      <svg viewBox="0 0 2500 50" {...props}>
        <LineOne x1="0" y1="0" x2="10000" y2="0" />
        <LineTwo x1="0" y1="50" x2="10000" y2="50" />
      </svg>
    </MonitorContainer>
  )
}

export default SystemMonitor
